import type { BadgeType } from '@src/Common/Components/UI/Badge.vue';

export function getMethodBadgeType(method: string): BadgeType {
    switch (method.toUpperCase()) {
        case 'GET':
            return 'info';
        case 'POST':
            return 'success';
        case 'PUT':
        case 'PATCH':
            return 'warning';
        case 'DELETE':
            return 'danger';
        case 'EXTRA':
        default:
            return 'muted';
    }
}

export function getColorBadgeType(color?: string): BadgeType {
    if (!color) {
        return 'muted';
    }

    switch (color.toLowerCase()) {
        case 'blue':
            return 'info';
        case 'green':
            return 'success';
        case 'yellow':
            return 'warning';
        case 'red':
            return 'danger';
        case 'purple':
            return 'error';
        default:
            return 'muted';
    }
}

export function getStatusBadgeType(status: number): BadgeType {
    if (status >= 200 && status < 300) {
        return 'success';
    } else if (status >= 300 && status < 400) {
        return 'warning';
    } else if (status >= 400 && status < 500) {
        return 'danger';
    } else if (status >= 500) {
        return 'error';
    } else {
        return 'muted';
    }
}

export function getRequestTypeBadgeType(type: string): BadgeType {
    switch (type) {
        case 'navigation':
            return 'info';
        case 'crud':
            return 'error';
        case 'partial':
        default:
            return 'muted';
    }
}
